import { useRetrieveStoreCardQuery, useDeleteStoreCardPassMutation, useDeleteStoreCardMutation, useRetrieveStoreCardStatisticsQuery } from 'services/storeCards';
import { StoreCard } from '../../../../ui/data-display/Passes/storeCard';
import { createTemplateDetails } from 'components/reusable/template';


export const StoreCardDetails = createTemplateDetails({
  TemplateRenderer: StoreCard,
  retrieveHook: useRetrieveStoreCardQuery,
  retrieveStatisticsHook: useRetrieveStoreCardStatisticsQuery,
  deletePassHook: useDeleteStoreCardPassMutation,
  deleteTemplateHook: useDeleteStoreCardMutation,
  baseUrl: '/store-cards/',
  i18nNamespace: 'storeCard',
})

